/* eslint-disable */

import React from 'react'
import PropTypes from 'prop-types'
import { compose, withProps } from 'recompose'
import { connect } from 'react-redux'
import { lpForm } from 'lp-form'
import { formValueSelector, propTypes as formPropTypes } from 'redux-form'
import { SubmitButton } from 'lp-components'
import { SectionBlock, SectionHeader } from 'components'
import { replaceResources, combineOtherOption } from 'utils'

import EducationSection from './education-section'
import ExperienceSection from './experience-section'
import LicenseSection from './license-section'
import * as Types from 'types'
import SkillSection from './skill-section'
import LearningSection from './learning-section'

const propTypes = {
  ...formPropTypes,
  flashErrorMessage: PropTypes.func.isRequired,
  flashSuccessMessage: PropTypes.func.isRequired,
  credentials: PropTypes.array,
  experiences: PropTypes.array,
  artistId: PropTypes.number.isRequired,
  approachTypes: PropTypes.arrayOf(Types.communityEnumerable).isRequired,
  disciplines: PropTypes.arrayOf(Types.communityEnumerable).isRequired,
  outcomeTypes: PropTypes.arrayOf(Types.communityEnumerable).isRequired,
  programTypes: PropTypes.arrayOf(Types.communityEnumerable).isRequired,
  languages: PropTypes.arrayOf(Types.communityEnumerable).isRequired,
}

const defaultProps = {}

function ExperienceSkillsForm({
  handleSubmit,
  submitting,
  change,
  flashErrorMessage,
  credentials,
  experiences,
  artistId,
  approachTypes,
  disciplines,
  skills,
  outcomeTypes,
  programTypes,
  languages,
}) {
  return (
    <form onSubmit={handleSubmit}>
      <SectionBlock>
        <SectionHeader>
          <h2 id="education-details">Education</h2>
          <div className="education-details-block">
            <div className="education-details-block-inner">
              <fieldset className="" aria-labelledby="education-details">
                <EducationSection
                  credentials={credentials}
                  change={change}
                  flashErrorMessage={flashErrorMessage}
                />
              </fieldset>
            </div>
          </div>
        </SectionHeader>
      </SectionBlock>
      <SectionBlock>
        <SectionHeader>
          <h2 id="experience-details">Experience</h2>
          <div className="experience-details-block">
            <div className="experience-details-block-inner">
              <fieldset className="" aria-labelledby="experience-details">
                <ExperienceSection
                  experiences={experiences}
                  change={change}
                  flashErrorMessage={flashErrorMessage}
                />
              </fieldset>
            </div>
          </div>
        </SectionHeader>
      </SectionBlock>
      <SectionBlock>
        <SectionHeader>
          <h2 id="license-details">Licenses & Certifications</h2>
          <div className="license-details-block">
            <div className="license-details-block-inner">
              <fieldset className="" aria-labelledby="license-details">
                <LicenseSection
                  credentials={credentials}
                  artistId={artistId}
                  change={change}
                  flashErrorMessage={flashErrorMessage}
                />
              </fieldset>
            </div>
          </div>
        </SectionHeader>
      </SectionBlock>
      <SectionBlock>
        <SectionHeader>
          <h2 id="skills-details">Skills & Offerings</h2>
          <div className="skills-details-block">
            <div className="skills-details-block-inner">
              <fieldset className="" aria-labelledby="skills-details">
                <SkillSection
                  skills={skills}
                  change={change}
                  flashErrorMessage={flashErrorMessage}
                  approachTypes={approachTypes}
                  disciplines={disciplines}
                  outcomeTypes={outcomeTypes}
                  programTypes={programTypes}
                  languages={languages}
                />
              </fieldset>
            </div>
          </div>
        </SectionHeader>
      </SectionBlock>
      <SectionBlock>
        <SectionHeader>
          <h2 id="learning-details">Professional Learning</h2>
          <div className="learning-details-block">
            <div className="learning-details-block-inner">
              <fieldset className="" aria-labelledby="learning-details">
                <LearningSection
                  credentials={credentials}
                  change={change}
                  flashErrorMessage={flashErrorMessage}
                />
              </fieldset>
            </div>
          </div>
        </SectionHeader>
      </SectionBlock>
      <SubmitButton submitting={submitting}>Save</SubmitButton>
    </form>
  )
}

ExperienceSkillsForm.propTypes = propTypes
ExperienceSkillsForm.defaultProps = defaultProps

function mapStateToProps(state, { name }) {
  return {
    credentials: formValueSelector(name)(state, 'credentials'),
    experiences: formValueSelector(name)(state, 'experiences'),
    skills: formValueSelector(name)(state, 'skills'),
  }
}

export default compose(
  connect(mapStateToProps),
  withProps(({ skills, flashErrorMessage }) => {
    // Helper to parse location string
    function parseLocation(fullLocation) {
      if (!fullLocation || typeof fullLocation !== 'string') {
        return { location_city: '', location_state: '', location_country: '' }
      }
      // Split by comma, trim whitespace
      const parts = fullLocation.split(',').map((p) => p.trim())
      let location_city = '',
        location_state = '',
        location_country = ''
      if (parts.length === 3) {
        ;[location_city, location_state, location_country] = parts
      } else if (parts.length === 2) {
        ;[location_city, location_country] = parts
      } else if (parts.length === 1) {
        location_city = parts[0]
      }
      return { location_city, location_state, location_country }
    }
    return {
      beforeSubmit: ({
        credentials,
        experiences,
        approaches,
        otherApproach,
        outcomes,
        otherOutcome,
        languages,
        otherLanguage,
        ...values
      }) => {
        const approachesResources = replaceResources({
          old: combineOtherOption(skills.approaches, skills.otherApproach),
          new: combineOtherOption(approaches, otherApproach),
        })

        const outcomesResources = replaceResources({
          old: combineOtherOption(skills.outcomes, skills.otherOutcome),
          new: combineOtherOption(outcomes, otherOutcome),
        })

        const languagesResources = replaceResources({
          old: combineOtherOption(skills.languages, skills.otherLanguage),
          new: combineOtherOption(languages, otherLanguage),
        })

        return {
          ...values,
          credentials: credentials
            .filter((credential) => !credential.isEditing)
            .map(({ isEditing, ...rest }) => rest),
          experiences: experiences
            .filter((experience) => !experience.isEditing)
            .map(({ isEditing, fullLocation, isCurrentPosition, ...rest }) => {
              const { location_city, location_state, location_country } =
                parseLocation(fullLocation)
              // Enforce required fields
              if (!location_city || !location_country) {
                flashErrorMessage(
                  'Location city and country are required for each experience. Please enter location in format: City, State, Country (e.g. Seattle, WA, USA)'
                )
              }
              const endDate = isCurrentPosition ? null : rest.endDate
              // Validate start date is before end date
              if (rest.startDate && endDate) {
                const startDate = new Date(rest.startDate)
                const endDateObj = new Date(endDate)
                if (startDate > endDateObj) {
                  flashErrorMessage(
                    'Start date must be before end date for each experience'
                  )
                }
              }
              return {
                ...rest,
                endDate,
                location_city,
                location_state,
                location_country,
              }
            }),
          languages: languagesResources,
          approaches: approachesResources,
          outcomes: outcomesResources,
        }
      },
    }
  }),
  lpForm({
    enableReinitialize: true,
  })
)(ExperienceSkillsForm)
